import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var styles$2 = {
  "label": "label-2h6uh",
  "labelOptional": "labelOptional-2h6uh"
};
var _excluded$2 = ["children", "className", "required", "optionalMessage"];

/**
 * This component does not include an input, just a label that is
 * used in multiple components. Thus, no has-associated-control or
 * label-has-for
 */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
var FieldLabel = _ref => {
  var {
      children,
      className,
      required,
      optionalMessage
    } = _ref,
    otherProps = _objectWithoutProperties$1(_ref, _excluded$2);
  var optional = !required && optionalMessage ? /*#__PURE__*/React.createElement("span", {
    className: styles$2.labelOptional
  }, "(", optionalMessage, ")") : null;
  return /*#__PURE__*/React.createElement("label", _extends$1({
    className: cs(styles$2.label, className)
  }, otherProps), children, " ", optional);
};
var propTypes$2 = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  required: PropTypes.bool.isRequired,
  optionalMessage: PropTypes.string
};
var defaultProps$2 = {
  className: null,
  optionalMessage: null
};
FieldLabel.propTypes = propTypes$2;
FieldLabel.defaultProps = defaultProps$2;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var styles$1 = {
  "hint": "hint-3BUcV",
  "hintSuccess": "hintSuccess-3BUcV",
  "hintWarning": "hintWarning-3BUcV",
  "hintError": "hintError-3BUcV"
};
var _excluded$1 = ["children", "className", "status"];
var FieldHint = _ref => {
  var {
      children,
      className,
      status
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cs(styles$1.hint, className, {
      [styles$1.hintSuccess]: status === 'success',
      [styles$1.hintWarning]: status === 'warning',
      [styles$1.hintError]: status === 'error'
    })
  }, otherProps), children);
};
var propTypes$1 = {
  children: PropTypes.node,
  className: PropTypes.string,
  status: PropTypes.oneOf(['success', 'warning', 'error'])
};
var defaultProps$1 = {
  children: null,
  className: null,
  status: null
};
FieldHint.propTypes = propTypes$1;
FieldHint.defaultProps = defaultProps$1;

var styles = {"radioButtonWrapper":"radioButtonWrapper-2ozUR","label":"label-2ozUR","icon":"icon-2ozUR","radioButton":"radioButton-2ozUR","labelWrapper":"labelWrapper-2ozUR"};

var _excluded = ["classes", "className", "disabled", "hint", "id", "name", "children", "required", "messages"];
var RadioButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      classes,
      className,
      disabled,
      hint,
      id,
      name,
      children,
      required,
      messages
    } = _ref,
    otherProps = _objectWithoutProperties$2(_ref, _excluded);
  var labelId = "".concat(id, "-label");
  var hintId = "".concat(id, "-hint");
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.radioButtonWrapper, className)
  }, /*#__PURE__*/React.createElement("input", _extends$2({
    className: cs(styles.radioButton, 'lll-hidden-visually'),
    "aria-labelledby": labelId,
    id: id,
    disabled: disabled,
    "aria-describedby": hint ? hintId : null,
    required: required,
    ref: ref,
    type: "radio",
    name: name
  }, otherProps)), /*#__PURE__*/React.createElement(FieldLabel, {
    className: cs(styles.label, classes.label),
    htmlFor: id,
    id: labelId,
    required: required,
    optionalMessage: messages && messages.optional
  }, /*#__PURE__*/React.createElement("span", {
    className: cs(styles.icon, classes.icon)
  }), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.labelWrapper, classes.labelContent)
  }, children)), hint && /*#__PURE__*/React.createElement(FieldHint, {
    id: hintId
  }, hint));
});
var propTypes = {
  classes: PropTypes.shape({
    icon: PropTypes.string,
    label: PropTypes.string,
    labelContent: PropTypes.string
  }),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /** Hint text for validation messages */
  hint: PropTypes.node,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  /** The field's label */
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  messages: PropTypes.shape({
    optional: PropTypes.string
  })
};
var defaultProps = {
  classes: {},
  className: null,
  disabled: false,
  hint: null,
  name: null,
  required: true,
  messages: {}
};
RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export { RadioButton, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
